export const handleEnterKey = (e, func) => {
  if (e.key !== "Enter") return;
  func();
};
